import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { addError, addSuccess } from 'actions/Error';
import { previousModalPage } from 'actions/modalPage';
import CloseButton from 'components/CustomButtons/CloseButton';
import SaveButton from 'components/CustomButtons/SaveButton';

import { GivexCard } from '../types';
import { GivexCardInput } from '../components/GivexCardInput';
import { transferBalance } from '../API/givexAPI';

/**
 * The transfer view allows the entire balance of one card to be transferred onto another
 *
 * This is commonly used to upgrade a customer from a non-pin card to a pin-enabled card
 */
const GivexTransfer = () => {
  const [fromCard, setFromCard] = useState<GivexCard>({ cardNo: '', pin: '' });
  const [toCard, setToCard] = useState<GivexCard>({ cardNo: '', pin: '' });

  const dispatch = useDispatch();
  const handleClose = () => dispatch(previousModalPage());
  const transferAndClose = (from: GivexCard, to: GivexCard) =>
    transferBalance(from, to)
      .then(handleClose)
      .then(() => dispatch(addSuccess(`Balance transfer successful`)))
      .catch(e => dispatch(addError(e.message)));

  return (
    <div data-testid="givex-giftcard-transfer">
      <Modal.Header>
        <Modal.Title>
          <h3 data-testid="title">
            <b>Gift card transfer</b>
          </h3>
        </Modal.Title>
        <div className="d-flex align-content-center">
          <SaveButton
            action={() => transferAndClose(fromCard, toCard)}
            disabled={!fromCard.cardNo || !toCard.cardNo}
            data-testid="save"
            title="Do transfer"
          />
          <CloseButton action={handleClose} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <h2 className="my-2">Transfer balance from card</h2>
        <GivexCardInput value={fromCard} onChange={setFromCard} />
        <h2 className="my-2">To card</h2>
        <GivexCardInput value={toCard} onChange={setToCard} />
      </Modal.Body>
    </div>
  );
};

export default GivexTransfer;
